import { FC } from 'react';
import { useIsSidebarCollapsed } from '@/shared/hooks';
import { RouteConfig } from '@/shared/lib';
import { SidebarNavItem } from '@/shared/ui';
import { useIsActive } from '@/widgets/MainLayout/model/hooks/useIsActive';
import { useIsRouteVisible } from '@/widgets/MainLayout/model/hooks/useIsRouteVisible';
import { AppSidebarLabel } from './AppSidebarLabel';
import { RouteNavIcon } from './RouteNavIcon';
import { SidebarFlyoutMenu } from './SidebarFlyoutMenu';

type Props = {
  route: RouteConfig;
  className?: string;
  /** Корневой пункт меню — только для таких в свёрнутом виде показывается меню-подсказка с названием */
  isRoot?: boolean;
};

export const AppSidebarItem: FC<Props> = (props) => {
  const { route, className, isRoot } = props;

  const { isActive } = useIsActive(route);
  const isCollapsed = useIsSidebarCollapsed();

  const isRouteVisible = useIsRouteVisible();

  // Динамические пункты, подключённые к самому пункту, зовёт он сам: маршрут у пункта один на всё
  // время жизни, поэтому и вызов хука постоянный, а перебор пунктов в группе хуков не зовёт
  const dynamicItems = route.navbar?.dynamicItems?.() ?? [];

  if (!isRouteVisible(route)) {
    return null;
  }

  const navItem = (
    <SidebarNavItem
      path={route.navbar?.path || route.path!}
      isActive={isActive}
      className={className}
      icon={<RouteNavIcon route={route} />}
      label={<AppSidebarLabel label={route.label} />}
    />
  );

  if (isRoot && isCollapsed) {
    return (
      <SidebarFlyoutMenu title={<AppSidebarLabel label={route.label} />} items={dynamicItems}>
        {navItem}
      </SidebarFlyoutMenu>
    );
  }

  return (
    <>
      {navItem}
      {/* Пункты, подключённые к самому пункту, — сразу под ним; у закрытого пункта их нет */}
      {dynamicItems.map((item) => (
        <SidebarNavItem key={item.key} path={item.path} icon={item.icon} label={item.label} />
      ))}
    </>
  );
};
